<template>
    <v-virtual-scroll
                    item-height="30"
                    max-height="400"
                    min-height="200"
                    :items="models"
                    bench="14"
    >
        <template v-slot="{ item }">
            <v-card outlined max-height="30"
                @click.exact="selectModel(item.appliedModelsXModelId)" 
                @click.shift.exact="selectModel(item.appliedModelsXModelId, 'shift')"
                @click.ctrl.exact="selectModel(item.appliedModelsXModelId, 'ctrl')"
                :class="isSelected(item.appliedModelsXModelId) ? 'blue darken-2 prevent-select white--text' : 'prevent-select'"
            >
                <v-card-text :class="isSelected(item.appliedModelsXModelId) ? 'pa-1 white--text model-card' : 'pa-1 black--text model-card'">
                    <p>{{ item.productNumber }} / {{ item.serialFrom }} / {{ item.serialTo }}</p>
                </v-card-text>
            </v-card>
        </template>
    </v-virtual-scroll>
</template>


<script>

export default {
  name: "Selection",
  components: {
  },
  props: {
      models: Array,
      clear: Number
  },
  data: () => ({
    selection: [],
    lastSelectedId: 0
  }),

  methods: {
    selectModel (selectedId, key) {
        switch (key) {
            case 'ctrl':
                this.lastSelectedId = selectedId;
                if (this.isSelected(selectedId)) {
                    this.selection = this.selection.filter(m => m.appliedModelsXModelId !== selectedId);
                }
                else{
                    this.selection.push(this.models.filter(m => m.appliedModelsXModelId === selectedId)[0]);
                }
                break;
            case 'shift':
                var firstIndex = this.models.map(m => m.appliedModelsXModelId).indexOf(this.lastSelectedId);
                var lastIndex = this.models.map(m => m.appliedModelsXModelId).indexOf(selectedId);

                var startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
                var endIndex = firstIndex <= lastIndex ? lastIndex + 1 : firstIndex + 1;

                this.selection = this.models.slice(startIndex, endIndex)
                break;
            default:
                this.lastSelectedId = selectedId;
                this.selection.length = 0;
                this.selection.push(this.models.find(m => m.appliedModelsXModelId === selectedId))
                break;
        }
    },

    isSelected(id) {
      return this.selection && this.selection.filter(m => m.appliedModelsXModelId === id).length > 0;
    }
  },
  watch: {
      clear () {
          this.selection.length = 0;
          this.$nextTick();
      },
      models: {
        handler () {
            this.$nextTick();
        },
        deep: true
      }
  }
};
</script>

<style scoped>
.prevent-select {
  user-select: none;
}
.model-card {
    font-size: 11px;
}
</style>